module.exports = __webpack_public_path__ + "img/2297.86fad700.gif";